import { SKIP, PropSchema } from 'serializr';

export function optional(propSchema: PropSchema): PropSchema {
    return {
        serializer: function (sourcePropertyValue: any) {
            const value = propSchema.serializer(sourcePropertyValue);
            return value === null ? SKIP : value;
        },
        deserializer: function (...args) {
            propSchema.deserializer(...args);
        }
    };
}
